import { SamplePack } from '@arpeggi/shared'
import moment from 'moment'

const preSaleHasExpired = (sp: SamplePack): boolean => {
  return (
    sp?.edition?.hasPresale &&
    sp?.edition?.preSaleEndTime &&
    moment() > moment(sp.edition.preSaleEndTime)
  )
}

const publicSaleHasExpired = (sp: SamplePack): boolean => {
  return sp?.edition?.publicSaleEndTime && moment() > moment(sp.edition.publicSaleEndTime)
}

export const saleIsExpired = (sp: SamplePack, isPresale: boolean) =>
  isPresale ? preSaleHasExpired(sp) : publicSaleHasExpired(sp)
